<template>
  <v-dialog
    max-width="800px"
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card class="mb-0">
      <v-toolbar dark color="primary" class="mb-2">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Características del Jugador</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row class="mb-6">
            <h3 class="mt-4">Jugador: {{ nombrePaciente }}</h3></v-row
          >
          <v-row>
            <v-col cols="12" md="4" sm="6">
              <v-select
                :items="categoriasModel"
                item-text="text"
                item-value="value"
                menu-props="auto"
                label="Categoría"
                hide-details
                v-model="categoria"
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-select
                :items="posiciones"
                item-text="text"
                item-value="value"
                menu-props="auto"
                label="Posición Favorita"
                hide-details
                v-model="posicion"
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" md="4" sm="6">
              <v-select
                :items="brazos"
                item-text="text"
                item-value="value"
                menu-props="auto"
                label="Brazo Hábil"
                hide-details
                v-model="brazo"
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="grey lighten-1" @click.stop="show = false"
          >Cancelar</v-btn
        >
        <v-btn color="warning" @click.stop="guardar()">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";
import { getCategoriasConfig } from "@/utils/models";

export default {
  name: "CaracteristicasJugador",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    idPaciente: {
      type: Number,
    },
    nombrePaciente: {
      type: String,
    },
  },
  data() {
    return {
      categoria: null,
      categoriasModel: [],
      brazo: null,
      brazos: [
        { text: "Diestro", value: "Diestro" },
        { text: "Zurdo", value: "Zurdo" },
      ],
      posicion: null,
      posiciones: [
        { text: "Drive", value: "Drive", },
        { text: "Revés", value: "Revés" },
        { text: "Indistinto", value: "Indistinto" },
      ],
    };
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.buscarCategorias();
          this.buscarCaracteristicas();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    vaciarModels() {
      this.categoria = null;
      this.posicion = null;
      this.brazo = null;
    },
    buscarCategorias() {
      this.categoriasModel = getCategoriasConfig(
        this.$store.state.usuario.institucion.idInstitucion,
      ).categorias;
    },
    async buscarCaracteristicas() {
      const { data: caracteristicas } = await axios.get(
        "/Paciente/BuscarCaracteristicas",
        {
          params: {
            idPaciente: this.idPaciente,
          },
        },
      );
      this.categoria = caracteristicas.categoria;
      this.brazo = caracteristicas.brazo;
      this.posicion = caracteristicas.posicion;
    },
    guardar() {
      const caracteristicas = {
        categoria: this.categoria,
        posicion: this.posicion,
        brazo: this.brazo,
        idPaciente: this.idPaciente,
      };
      let self = this;
      axios
        .post("/Paciente/GuardarCaracteristicas", caracteristicas)
        .then(() => {
          self.showAlert({
            icon: "success",
            title: "Características guardadas exitosamente",
            vm: self,
            timer: 2000,
          });
          self.$emit("close");
        })
        .catch(() => {
          self.showAlert({
            icon: "error",
            title:
              "Las características no pudieron ser guardadas. Intente nuevamente más tarde.",
            vm: self,
            timer: 2000,
          });
        });
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
};
</script>
